<script lang="ts" setup>
type Props = {
  color?: string;
};

withDefaults(defineProps<Props>(), {
  color: "#000",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
  >
    <rect
      x="0.5"
      y="-0.5"
      width="29"
      height="29"
      rx="14.5"
      transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 -4.37114e-08 29.0406)"
      :stroke="color"
    />
    <path
      d="M6.46967 14.5103C6.17678 14.8032 6.17678 15.2781 6.46967 15.571L11.2426 20.344C11.5355 20.6368 12.0104 20.6368 12.3033 20.344C12.5962 20.0511 12.5962 19.5762 12.3033 19.2833L8.06066 15.0407L12.3033 10.798C12.5962 10.5051 12.5962 10.0302 12.3033 9.73735C12.0104 9.44446 11.5355 9.44446 11.2426 9.73735L6.46967 14.5103ZM23.5 15.7907C23.9142 15.7907 24.25 15.4549 24.25 15.0407C24.25 14.6264 23.9142 14.2907 23.5 14.2907L23.5 15.7907ZM7 15.7907L23.5 15.7907L23.5 14.2907L7 14.2907L7 15.7907Z"
      :fill="color"
    />
  </svg>
</template>
